// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rslv","question":"styles_question__3W8YL","description":"styles_description__bcRh6"};